import $ from "jquery";
import template from "lodash.template";
import AjaxList from "../../components/ajaxList";
import { format } from "../../utils/currency";
import { localeDate } from "../../utils/date";
import i18n from "../../utils/translate";

class Module {
  constructor($module) {
    this.$container = $module.find(".js-history-list");
    this.$list = $module.find(".b-networks__list_wrap");
    this.$totalAmount = $module.find(".js-total-amount");
    this.currency = $module.data("currency");
    this.template = template($module.find(".js-partner-template").html());

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find(".js-partner-filter-form"),
      $load: $module.find(".js-load-payments"),
      append: (response, replace) => {
        this.$totalAmount.html(format(response.total_amount, this.currency));
        return this.append(response, replace);
      }
    });
  }

  append(response, replace) {
    if (replace) {
      this.$list.empty();
    }

    if (!response.payments.length) {
      this.$container.addClass("empty_list");
    } else {
      this.$container.removeClass("empty_list");

      let content = "";
      let prevDate = replace
        ? null
        : $.trim(this.$container.find(".b-networks__subtitle:last").text());
      let date = null;

      response.payments.forEach(v => {
        date = localeDate(v.created_at);

        content += this.render(v, date !== prevDate ? date : null);
        prevDate = date;
      });

      this.$list.append(content);
    }
  }

  render(value, date) {
    return this.template({
      id: value.id,
      date: date,
      direction: value.direction,
      eventClass: value.status === "canceled" ? "b-event_inactive" : "",
      status: value.status,
      statusName: i18n.gettext(value.status_name),
      amount: format(value.amount, value.currency)
    });
  }
}

$(function() {
  $(".js-partner-account").each(function() {
    new Module($(this));
  });
});
